import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import { useTrackWithUser } from '@ion/api';
import { SearchIcon } from '@metarouter-private/mr-mui';

import { routes } from 'app/constants';
import { buildEventDebuggerLocationState } from 'app/event-monitoring/event-debugger/event-debugger-table/EventDebuggerTableContext';
import { usePipelinePageContext } from 'app/pipeline-details/PipelinePageContextProvider';
import ActionIconButton from 'app/pipeline-details/PipelineIntegrationsSection/PipelineIntegrations/PipelineIntegrationsTable/cells/shared/ActionIconButton';

export default function OpenEventDebuggerButton({ integration }) {
  const history = useHistory();
  const { pipeline } = usePipelinePageContext();
  const [trackEventDebuggerOpened] = useTrackWithUser('pipeline_integration_event_debugger_opened');

  const onClick = () => {
    trackEventDebuggerOpened({ starterkitId: integration.starterkitId });
    history.push(
      routes.eventMonitoring,
      buildEventDebuggerLocationState({
        clusterId: pipeline.clusterId,
        writekey: pipeline.writekey,
        integrationId: integration.id,
      })
    );
  };

  return (
    <ActionIconButton
      tooltipMessage="View in Event Debugger"
      ariaLabel={`View ${integration.name} events in the Event Debugger`}
      dataTestId="openEventDebuggerButton"
      onClick={onClick}
    >
      <SearchIcon color="action" fontSize="medium" />
    </ActionIconButton>
  );
}

OpenEventDebuggerButton.propTypes = {
  integration: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    starterkitId: PropTypes.string.isRequired,
  }).isRequired,
};
